import React, { useState, useEffect } from "react";
import { PieChart } from "react-minimal-pie-chart";
import { Link } from "react-router-dom";
import { Container, Grid } from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import axios from "axios";
import {
  getUserId,
  GetavailableLeave,
  HEADERS,
  LeaveRequestNotification,
  GetenabledLeave,
  getLeaPId,
  DeleteLeaveRequest,
} from "../api";
import { deleteLeaveRequest } from "../../services/apiFunctions";

function LeaveNavigation() {
  const [activeButton, setActiveButton] = useState("Casual");
  const [animationKey, setAnimationKey] = useState(0);
  const [notificationRequest, setNotificationRequest] = useState([]);
  const [leaveTypeData, setLeaveTypeData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [statValues, setStatValues] = useState({
    totalDays: "",
    approved: "",
    pending: "",
    remainingDays: "",
  });

  const [page, setPage] = useState(0); // Track the current page
  const [pageSize, setPageSize] = useState(5); // Track the page size

  useEffect(() => {
    const fetchData = async () => {
      const UserID = getUserId();
      try {
        const requestData = { user_id: UserID };
        const response = await axios.post(
          LeaveRequestNotification,
          requestData,
          { headers: HEADERS }
        );
        if (response.data.response_code === "0000") {
          setNotificationRequest(response.data.data);
        } else {
          // console.error("Error fetching leave type. Please try again later.");
        }
      } catch (error) {
        // console.error("An error occurred while fetching leave type:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const enabledLeaveTypesResponse = await axios.post(
          GetenabledLeave,
          { lp_id: getLeaPId() },
          { headers: HEADERS }
        );

        if (enabledLeaveTypesResponse.data.response_code === "0000") {
          const enabledLeaveTypes = enabledLeaveTypesResponse.data.data;

          const leaveTypeDataPromises = enabledLeaveTypes.map(
            async (leaveType) => {
              const leaveTypeResponse = await axios.post(
                GetavailableLeave,
                { user_id: getUserId(), leave_type: leaveType.leave_type_id },
                { headers: HEADERS }
              );

              if (leaveTypeResponse.data.response_code === "0000") {
                return leaveTypeResponse.data.data[0];
              }
              return null;
            }
          );

          const leaveTypeDataResults = await Promise.all(leaveTypeDataPromises);
          const filteredLeaveTypeData = leaveTypeDataResults.filter(
            (data) => data !== null
          );

          // ✅ Sort alphabetically by leave_type_name
          const sortedLeaveTypeData = filteredLeaveTypeData.sort((a, b) =>
            a.leave_type_name.localeCompare(b.leave_type_name)
          );

          setLeaveTypeData(sortedLeaveTypeData);

          if (sortedLeaveTypeData.length > 0) {
            handleButtonClick(
              sortedLeaveTypeData[0].leave_type_name,
              sortedLeaveTypeData
            );
          }
        } else {
          console.error(
            "Error fetching enabled leave types. Please try again later."
          );
        }
      } catch (error) {
        console.error(
          "An error occurred while fetching enabled leave types:",
          error
        );
      }
    };

    fetchData();
  }, [getLeaPId()]);

  const handleDelete = async (LeaveReqId) => {
    try {
      const confirmDelete = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Leave Request!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#2D7D9F",
        cancelButtonColor: "grey",
        reverseButtons: true,
      });
      if (confirmDelete.isConfirmed) {
        const UserID = getUserId();
        const requestBody = {
          leave_request_id: LeaveReqId,
          leave_requested_by: UserID,
        };

        try {
          const response = await deleteLeaveRequest(requestBody);
          console.log("asdf", response);
          if (response.response_code === "0000") {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: response.response_description,
              confirmButtonColor: "#2D7D9F",
            }).then((result) => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: response.response_message,
              text: response.response_description,
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Request Error",
            text: "Something went wrong. Please try again.",
          });
        }
      }
    } catch (error) {
      console.error("An error occurred while deleting Leave Request:", error);
    }
  };

  const handleButtonClick = (value, leaveTypes) => {
    const leaveType = leaveTypes.find((data) => data.leave_type_name === value);

    if (leaveType) {
      const consumedDays = leaveType.consumed_days || 0; // Use 0 for null/undefined
      const pendingLeave = leaveType.pending_leave || 0; // Use 0 for null/undefined
      const totalDays = leaveType.total_days || 0; // Total allocated days

      const remainingUsableDays = totalDays - consumedDays;

      const newChartData = [
        {
          title: "Approved",
          value: consumedDays,
          color: "#C8E3ECFF",
        },
        // {
        //   title: "Pending",
        //   value: pendingLeave,
        //   color: "#FFD700",
        // },
        {
          title: "Remaining",
          value: Math.max(0, remainingUsableDays),
          color: "#2D7D9FFF",
        },
      ].filter((segment) => segment.value > 0);

      const newStatValues = {
        totalDays: totalDays,
        approved: consumedDays,
        pending: pendingLeave,
        remainingDays: Math.max(0, remainingUsableDays), // Consistent with chart
      };

      setChartData(newChartData);
      setStatValues(newStatValues);
      setActiveButton(value);
      setAnimationKey((prevKey) => prevKey + 1); // Trigger animation
    } else {
      setChartData([]);
      setStatValues({
        totalDays: "",
        approved: "",
        pending: "",
        remainingDays: "",
      });
      setActiveButton(value); // Still set active button even if no data
    }
  };

  const handleFormSubmit = () => {};

  const isActive = (value) => {
    return value === activeButton ? "active-button" : "";
  };
  const tableData = notificationRequest.map((datas) => ({
    leave_request_id: datas.leave_request_id,
    leave_type: datas.leave_type,
    begin_date: datas.begin_date,
    end_date: datas.end_date,
    days_off: datas.days_off,
    leave_status: datas.leave_status,
    delete:
      datas.leave_status === "Pending" || datas.leave_status === "Forwarded" ? (
        <FontAwesomeIcon
          style={{ cursor: "pointer" }}
          onClick={() =>
            handleDelete(datas.leave_request_id, datas.leave_requested_by)
          }
          icon={faTrash}
        />
      ) : null,
  }));
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const tableColumns = [
    {
      accessorKey: "leave_type",
      header: "Leave Type",
    },
    {
      accessorKey: "begin_date",
      header: "Start Date",
    },
    {
      accessorKey: "end_date",
      header: "End Date",
    },

    {
      accessorKey: "days_off",
      header: "Days Off",
    },

    {
      accessorKey: "leave_status",
      header: "Status",
    },
    {
      accessorKey: "delete",
      header: "Delete",
    },
  ];
  const handlePageChange = (newPage) => {
    setPage(newPage); // Update the current page
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize); // Update the page size
  };
  return (
    <div>
      <Container fluid>
        <Grid>
          <div style={{ width: "100%" }} className="row-container">
            <span className="title">Leave Statistics</span>
            <div className="border rounded p-2">
              <div className="row position-relative align-items-center justify-content-center">
                <div className="position-relative col-md-3">
                  <PieChart
                    key={animationKey}
                    data={chartData}
                    radius={40}
                    lineWidth={35}
                    segmentsStyle={{
                      transition: "stroke .5s",
                      cursor: "pointer",
                    }}
                    animate
                  />
                  <div className="position-absolute top-50 text-center start-50 translate-middle">
                    <span className="" style={{ fontSize: "14px" }}>
                      {statValues.remainingDays} Days
                    </span>
                    <p className="" style={{ fontSize: "14px" }}>
                      Remaining
                    </p>
                  </div>
                </div>
                <div className="row stat-row  col-md-9">
                  <div className="col-sm row-stat d-flex rounded align-items-center justify-content-between">
                    <div className="stat-box">
                      <h6 className="type-leav">Total Days</h6>
                      <span className="leave-value" style={{ color: "#fff" }}>
                        {statValues.totalDays}
                      </span>
                    </div>
                    <div className="stat-box">
                      <i
                        style={{ color: "#fff " }}
                        className="fa fa-solid fa-list"
                      ></i>
                    </div>
                  </div>
                  <div className="col-sm row-stat rounded d-flex align-items-center justify-content-between">
                    <div className="stat-box">
                      <h6 className="type-leav">Approved</h6>
                      <span className="leave-value" style={{ color: "#fff" }}>
                        {statValues.approved}
                      </span>
                    </div>
                    <div className="stat-box">
                      <i className="fa fa-check"></i>
                    </div>
                  </div>
                  <div className="col-sm row-stat rounded d-flex align-items-center justify-content-between">
                    <div className="stat-box">
                      <h6 className="type-leav">Pending</h6>
                      <span className="leave-value" style={{ color: "#fff" }}>
                        {statValues.pending}
                      </span>
                    </div>
                    <div className="stat-box">
                      <i className="fa fa-regular fa-hourglass-half"></i>
                    </div>
                  </div>
                  <div className="leave-button">
                    {leaveTypeData.map((leaveType) => (
                      <button
                        key={leaveType.leave_type}
                        className={`btn border button ${
                          isActive(leaveType.leave_type_name) ? "active" : ""
                        }`}
                        onClick={() =>
                          handleButtonClick(
                            leaveType.leave_type_name,
                            leaveTypeData
                          )
                        }
                        style={{
                          backgroundColor: isActive(leaveType.leave_type_name)
                            ? "#2d7d9f"
                            : "#c8e3ec",
                          color: isActive(leaveType.leave_type_name)
                            ? "#FFFFFFFF"
                            : "#2d7d9f",
                        }}
                      >
                        <span className="type-leav">
                          {leaveType.leave_type_name}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Grid.Col xs={12}>
            <div className="heading-section mt-3 d-flex jutify-content-between">
              <div
                style={{ width: "100%" }}
                className="p-2 d-flex justify-content-between"
              >
                <h5 className="title">Leave Application</h5>
              </div>
            </div>
            <div className="d-flex pb-2">
              <Link
                to="/UserApproval"
                className="ms-auto"
                style={{ textDecoration: "none" }}
                onClick={handleFormSubmit}
              >
                <button className="add-button">Add Request</button>
              </Link>
            </div>

            <div className="tab">
              <MantineReactTable
                columns={tableColumns}
                enableFullScreenToggle={false}
                data={tableData}
                mantineTableBodyCellProps={{
                  style: {
                    backgroundColor: "#C8E3EC60",
                    color: "#505050",
                    border: "0.5px solid #fff",
                    padding: "10px",
                  },
                }}
                mantineTableHeadCellProps={{
                  style: {
                    backgroundColor: "#2d7d9f",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#fff",
                    border: "1px solid #fff",
                  },
                }}
                mantineTableBodyRowProps={(row) => ({
                  style: {
                    backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
                  },
                })}
                enablePagination={false}
                // enableColumnResizing
                enableColumnOrdering
              />
              <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="d-flex align-items-center gap-2">
                  <span style={{ fontSize: "14px" }}>Items per page:</span>
                  <select
                    className="form-select"
                    style={{ width: "110px" }}
                    value={pageSize}
                    onChange={(e) =>
                      handlePageSizeChange(parseInt(e.target.value))
                    }
                  >
                    <option value={5}>5 rows</option>
                    <option value={10}>10 rows</option>
                    <option value={20}>20 rows</option>
                    <option value={50}>50 rows</option>
                    <option value={100}>100 rows</option>
                  </select>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <span style={{ fontSize: "14px" }}>
                    {totalRows === 0
                      ? "Showing 0 to 0 of 0 entries"
                      : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
                  </span>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <button
                    className="previous-button"
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 0}
                  >
                    Previous
                  </button>
                  <button
                    className="add-button text-center justify-content-center"
                    style={{ width: "100px" }}
                    onClick={() => handlePageChange(page + 1)}
                    disabled={(page + 1) * pageSize >= tableData.length}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </Grid.Col>
        </Grid>
      </Container>
    </div>
  );
}

export default LeaveNavigation;
